import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Button, Typography } from '@mui/material';
import LayoutUserHeader from '../components/LayoutUserHeader';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const PurchaseInvoiceExcelUploader = () => {
  const [formattedData, setFormattedData] = useState([]);
  const [fileName, setFileName] = useState(null);
  const navigate = useNavigate();

  const excelDateToJS = (excelDate) => {
    if (!excelDate) return null;
    if (typeof excelDate === "number") {
      return new Date((excelDate - 25569) * 86400 * 1000); // Excel serial date
    }
    return new Date(excelDate);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: "binary" });

        // Sheet1 → Invoice header
        const sheet1Data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]) || [];
        // Sheet2 → Products
        const sheet2Data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]]) || [];

        const invoicesMap = {};

        // --- Step 1: Prepare headers ---
        sheet1Data.forEach((row) => {
          const key = row.InvoiceNumber;
          if (!key) return;

          invoicesMap[key] = {
            InvoiceNumber: row.InvoiceNumber,
            InvoiceDate: excelDateToJS(row.InvoiceDate),
            StateId: row.StateId,
            StateCode: row.StateCode,
            GRNumber: row.GRNumber,
            TransportDate: excelDateToJS(row.TransportDate),
            PlaceOfSupply: row.PlaceOfSupply,
            VehicleNumber: row.VehicleNumber,
            TranspotationMode: row.TranspotationMode,
            TransporterName: row.TransporterName,
            CustomerName: row.CustomerName,
            CustomerAddress: row.CustomerAddress,
            CustomerStateId: row.CustomerStateId,
            CustomerStateCode: row.CustomerStateCode,
            CustomerGSTNumber: row.CustomerGSTNumber,
            GSTNumber: row.GSTNumber,
            SupplierType: row.SupplierType,
            Products: [],
            TotalAmount: parseFloat(row.TotalAmount) || 0
          };
        });

        // --- Step 2: Attach Products ---
        sheet2Data.forEach((row) => {
          const key = row.InvoiceNumber;
          if (!key || !invoicesMap[key]) return;

          invoicesMap[key].Products.push({
            ProductId: row.ProductId,
            HSNCode: row.HSNCode,
            Quantity: parseFloat(row.Quantity) || 0,
            Unit: row.Unit,
            Rate: parseFloat(row.Rate) || 0,
            Amount: parseFloat(row.Amount) || 0,
            IGSTPercentage: parseFloat(row.IGSTPercentage) || 0,
            CGSTPercentage: parseFloat(row.CGSTPercentage) || 0,
            SGSTPercentage: parseFloat(row.SGSTPercentage) || 0,
            IGSTAmount: parseFloat(row.IGSTAmount) || 0,
            CGSTAmount: parseFloat(row.CGSTAmount) || 0,
            SGSTAmount: parseFloat(row.SGSTAmount) || 0,
            DiscountAmount: parseFloat(row.DiscountAmount) || 0,
            OtherCharges: parseFloat(row.OtherCharges) || 0,
            Cess: parseFloat(row.Cess) || 0
          });
        });

        setFormattedData(Object.values(invoicesMap).filter(inv => inv.Products.length > 0));

      } catch (err) {
        console.error("Error reading Excel:", err);
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleUpload = async () => {
    if (!formattedData.length) {
      alert("⚠️ No data to upload. Please upload an Excel file first.");
      return;
    }

    try {
      const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/PurchaseInvoice/BulkUpload`,
  formattedData,
  {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }
);
const updatedInvoicesList = res.data.updatedList; // backend returns all invoices

// trigger a refresh in dashboard
window.dispatchEvent(new CustomEvent('refreshDashboard', { detail: updatedInvoicesList }));
      
      alert("✅ Purchase Invoices uploaded successfully");
      navigate('/GetPurchaseInvoices');
      console.log(res.data);
    } catch (err) {
      console.error("Upload failed:", err.response || err.message);
      alert("❌ Upload failed, check console for details");
    }
  };

  return (
    <>
      <LayoutUserHeader />
      <div style={{ marginTop: '6rem', textAlign: 'center' }}>
        <Typography variant="h6">Upload Purchase Invoices (Excel)</Typography>
        <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
        {fileName && <Typography variant="subtitle2">File: {fileName}</Typography>}
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          style={{ marginTop: '1rem' }}
        >
          Upload
        </Button>
      </div>
    </>
  );
};

export default PurchaseInvoiceExcelUploader;
